import { Pipe, PipeTransform } from '@angular/core';

// FROM: http://codebuckets.com/2018/01/23/angular-pipe-to-truncate-text-to-the-nearest-whole-word/
@Pipe({
  name: 'truncateText'
})
export class TruncateTextPipe implements PipeTransform {

  transform(value: string, length: number): string {
    const biggestWord = 50;
    const elipses = '...';

    if (typeof value === 'undefined' || value === null) {
      return value;
    }
    if (value.length <= length) {
      return value;
    }

    // .. truncate to about correct lenght
    let truncatedText = value.slice(0, length + biggestWord);

    // .. now nibble ends till correct length
    while (truncatedText.length > length - elipses.length) {

      const lastSpace = truncatedText.lastIndexOf(' ');
      if (lastSpace === -1) {
        break;
      }
      truncatedText = truncatedText.slice(0, lastSpace).replace(/[!,.?;:]$/, '');

    }

    return truncatedText + elipses;

  }
}
